import { UserDTO } from '../../api/model';
import { Action } from '../root-reducer';
import { actionTypes as at } from './constants';

interface MyAccount {
    loggedIn: boolean;
    myProfile?: UserDTO;
}

const initialState: MyAccount = {
    loggedIn: false,
    myProfile: undefined,
};

export default (state: MyAccount = initialState, action: Action): MyAccount => {
    switch (action.type) {
        case at.GET_MY_PROFILE_SUCCESS:
            return { ...state, myProfile: action.payload, loggedIn: true };

        case at.LOGOUT_USER:
            return { ...state, myProfile: undefined, loggedIn: false };
        default:
            return { ...state };
    }
};
